import { Column, Entity, PrimaryColumn } from 'typeorm';
import { User } from '../../_objects/user';
import { IPC_CHANNEL } from '../electron.constants';

@Entity()
export class CurrentUserSchema {
  @PrimaryColumn()
    columnId: string;

  @Column({ nullable: true })
    id: string | null;

  @Column({ nullable: true })
    givenName: string | null;

  @Column({ nullable: true })
    surname: string | null;

  @Column({ nullable: true })
    initials: string | null;

  @Column({ nullable: true })
    isAgreedTerms: boolean | null;

  @Column({ nullable: true })
    accountEnabled: boolean | null;

  @Column({ nullable: true })
    country: string | null;

  @Column({ nullable: true })
    schemaVersion: string | null;

  @Column({ nullable: true })
    tenantAttributes: string | null;

  constructor(user?: User) {
    this.columnId = IPC_CHANNEL.CURRENT_USER.ID;
    if (user) {
      this.id = user.id;
      this.givenName = user.givenName;
      this.surname = user.surname;
      this.initials = user.initials;
      this.isAgreedTerms = user.isAgreedTerms;
      this.accountEnabled = user.accountEnabled;
      this.country = user.country;
      this.schemaVersion = user.schemaVersion;
      this.tenantAttributes = JSON.stringify(user.tenantAttributes);
    }
  }
}
